Namespace 'Common.Dashboard.Charts'

class Common.Dashboard.Charts.ResizableOptionsView extends Backbone.View
  template: JST['backbone/templates/common/dashboard/charts/resizable_options']

  events:
    'click .toggle-maximize': 'toggleMaximize'

  initialize: ({@isMaximized}) ->

  render: =>
    @$el.html @template
      title: @_title()
    @

  _title: =>
    option = if @isMaximized then 'minimize' else 'maximize'
    I18n.t('customer_visual_mode.charts.resize_options.' + option)

  toggleMaximize: =>
    @trigger('chart:toggleMaximize')

  updateTitle: (isMaximized) =>
    @isMaximized = isMaximized
    @$el.find('.toggle-maximize').html(@_title())
